module.exports = __webpack_public_path__ + "img/logo_stasis.15a4c1e2.png";